export default "__VITE_ASSET__55fc430c__"